import * as H from 'history'

export const createUrlWithHost = (path: string) => `${location.origin}${path}`

export const formatPathQueryParam = (path: string | string[] | null | undefined) =>
  typeof path === 'string' && path.startsWith('/') ? path : null

export const currentPathWithSearch = (location: H.Location<any>) => `${location.pathname}${location.search}`
